import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { buzzComments } from '@/mocks/home';

export default function CommentBuzz() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [hint, setHint] = useState(false);

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section
      id="buzz"
      className="w-full bg-secondary-50 border-y border-secondary-200 py-14 md:py-20 px-4 md:px-8"
    >
      <div className="w-full max-w-[1180px] mx-auto">
        <SectionHeading
          eyebrow="Comment Buzz"
          icon="ri-chat-smile-2-line"
          title="评论区氛围：讨论最热的声音都在这"
          desc="板块负责归档，评论区负责发散。这里汇总各板块下互动量最高的评论，看看大家到底在聊什么。"
          align="center"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {buzzComments.map((comment) => {
            const isLiked = !!liked[comment.id];
            return (
              <article
                key={comment.id}
                className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-3-line text-lg"></i>
                  </span>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-foreground-900 font-medium truncate">{comment.user}</span>
                      {comment.top ? (
                        <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-800 text-[11px] whitespace-nowrap">
                          置顶热评
                        </span>
                      ) : null}
                    </div>
                    <span className="text-[11px] md:text-xs text-foreground-500">{comment.meta}</span>
                  </div>
                </div>

                <p className="mt-4 flex-1 text-xs md:text-sm text-foreground-700 leading-relaxed">
                  {comment.text}
                </p>

                <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                  <button
                    type="button"
                    onClick={() => toggleLike(comment.id)}
                    className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap ${
                      isLiked
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-100 text-foreground-600 hover:text-primary-700'
                    }`}
                  >
                    <i className={isLiked ? 'ri-heart-3-fill' : 'ri-heart-3-line'}></i>
                    {comment.likes + (isLiked ? 1 : 0)}
                  </button>
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-chat-1-line"></i>
                    {comment.replies} 条回复
                  </span>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch gap-3 max-w-3xl mx-auto">
          <div className="flex-1 flex items-center gap-3 h-12 px-4 rounded-lg border border-secondary-300 bg-background-50 text-foreground-500">
            <i className="ri-edit-2-line text-sm"></i>
            <input
              type="text"
              placeholder="说说你对哪个板块的哪条内容最有话说"
              className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            onClick={() => setHint(true)}
            className="h-12 px-6 rounded-lg bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            参与讨论
          </button>
        </div>
        {hint ? (
          <p className="mt-3 text-center text-xs text-foreground-500">
            当前为静态展示页，评论提交入口暂未开放，可先浏览板块索引。
          </p>
        ) : null}
      </div>
    </section>
  );
}